// extracted by mini-css-extract-plugin
export default {"top_block":"TopBlock_top_block__mbTnz","contacts_wrapper":"TopBlock_contacts_wrapper__RGT5D","call_btn":"TopBlock_call_btn__J1yJX"};